"use strict";
/**
 * @carbowaste/excel-sheet-template-loader
 *
 * Excel sheet template loader for CARBOwaste applications
 * Loads and applies Excel templates from API with full formatting support
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTemplateLoader = exports.createSheetFromData = void 0;
// Core functionality - template loading
var TemplateLoaderWrapper_1 = require("./TemplateLoaderWrapper");
Object.defineProperty(exports, "createSheetFromData", { enumerable: true, get: function () { return TemplateLoaderWrapper_1.createSheetFromData; } });
// React hook for template loading
var useTemplateLoader_1 = require("./hooks/useTemplateLoader");
Object.defineProperty(exports, "useTemplateLoader", { enumerable: true, get: function () { return useTemplateLoader_1.useTemplateLoader; } });
//# sourceMappingURL=index.js.map